import {
  NavBarBackButton,
  BodyMedium,
  BodyLargeEmphasized,
  BodyMediumMidEmphasis,
  useSnackbar,
  Switch,
} from '@/design-system';
import colors from '@/theme/colors';
import { useNotificationPreferences } from '@/hooks/useNotificationPreferences';
import styles from './Notifications.styles';
import { useContext } from 'react';
import UserPreferencesContext from '@/context/UserPreferencesContext';
import { DEFAULT_ERROR_MESSAGE } from '@/config/constants';
import { LiveFeedback, PeachjarLoader } from '@/components';
import { useLiveFeedback } from '@/hooks';

export const Notifications: React.FC = () => {
  // const { notifications, setNotifications } = useNotificationPreferences();
  const { notificationPreferences, updateNotificationPreferences, loading } =
    useContext(UserPreferencesContext);
  const [feedbackMessage, setFeedbackMessage] = useLiveFeedback({ delay: 2000 });
  const showToast = useSnackbar();

  // const showDeliverySection = Object.keys(notifications.content).some(
  //   key => notifications.content[key] === true,
  // );

  const onContentChange = async (notification: string) => {
    const newNotifications = {
      ...notificationPreferences,
      [notification]: !notificationPreferences[notification],
    };
    const success = await updateNotificationPreferences({
      content: newNotifications,
    });

    if (success) {
      const successMessage = 'Notification Preferences Saved';
      showToast({ message: successMessage });
      setFeedbackMessage(successMessage);
    } else {
      showToast({ message: DEFAULT_ERROR_MESSAGE });
      setFeedbackMessage(DEFAULT_ERROR_MESSAGE);
    }
    // const newNotifications = {
    //   ...notifications,
    //   content: {
    //     ...notifications.content,
    //     [notification]: !notifications.content[notification],
    //   },
    // };
    // const { email, push } = newNotifications.delivery;
    // if (!email && !push) {
    //   if (
    //     Object.keys(newNotifications.content).some(
    //       key => newNotifications.content[key],
    //     )
    //   ) {
    //     setNotifications({
    //       ...newNotifications,
    //       delivery: {
    //         email: true,
    //         push: true,
    //       },
    //     });
    //   }
    // } else {
    //   setNotifications(newNotifications);
    // }
  };

  // const onDeliveryChange = (notification: string) => {
  //   const newNotifications = {
  //     ...notifications,
  //     delivery: {
  //       ...notifications.delivery,
  //       [notification]: !notifications.delivery[notification],
  //     },
  //   };

  //   const { email, push } = newNotifications.delivery;
  //   if (!email && !push) {
  //     setNotifications({
  //       ...newNotifications,
  //       content: {
  //         newFlyer: false,
  //         savedSearch: false,
  //         upcoming: false,
  //       },
  //     });
  //   } else {
  //     setNotifications(newNotifications);
  //   }
  // };

  const onNewFlyerChange = async () => {
    await onContentChange('newFlyer');
  };

  const { newFlyer } = notificationPreferences;

  return (
    <>
      <PeachjarLoader loading={loading} />
      <NavBarBackButton trackId="notificationsPage">Notifications</NavBarBackButton>
      <div className={styles.container}>
        <BodyMedium color={colors.slate}>
          Receive email notifications about flyers from your children's schools or community
          organizations offering approved child enrichment resources.
        </BodyMedium>
        <div>
          <LiveFeedback message={feedbackMessage} ariaLive="assertive" />
          <div className={styles.label}>
            <BodyLargeEmphasized>Email Notifications</BodyLargeEmphasized>
          </div>
          <div className={styles.section}>
            <label
              className={styles.sectionItem}
              style={{ cursor: 'pointer' }}
              onClick={onNewFlyerChange}
            >
              <BodyMediumMidEmphasis as="span">New Flyer</BodyMediumMidEmphasis>
              <Switch
                checked={newFlyer}
                onChange={onNewFlyerChange}
                data-testid="newFlyer"
                id="newFlyerSwitch"
                ariaLabel="New Flyer"
              />
            </label>
            {/* <div className={styles.sectionItem}>
              <BodyMediumMidEmphasis>Saved Search</BodyMediumMidEmphasis>
              <Switch
                className={styles.switchInput}
                checked={content.savedSearch}
                onChange={() => onContentChange('savedSearch')}
              />
            </div>
            <div className={styles.sectionItem}>
              <BodyMediumMidEmphasis>
                Upcoming Saved Flyers
              </BodyMediumMidEmphasis>
              <Switch
                className={styles.switchInput}
                checked={content.upcoming}
                onChange={() => onContentChange('upcoming')}
              />
            </div> */}
          </div>
        </div>
        {/* {showDeliverySection && (
          <div>
            <div className={styles.label}>
              <BodyLargeEmphasized>Delivery</BodyLargeEmphasized>
            </div>
            <div className={styles.section}>
              <div className={styles.sectionItem}>
                <BodyMediumMidEmphasis>Email</BodyMediumMidEmphasis>
                <Switch
                  className={styles.switchInput}
                  checked={delivery.email}
                  onChange={() => onDeliveryChange('email')}
                />
              </div>
              <div className={styles.sectionItem}>
                <BodyMediumMidEmphasis>Push</BodyMediumMidEmphasis>
                <Switch
                  className={styles.switchInput}
                  checked={delivery.push}
                  onChange={() => onDeliveryChange('push')}
                />
              </div>
            </div>
          </div>
        )} */}
      </div>
    </>
  );
};
